import { render, staticRenderFns } from "./home-tabs.vue?vue&type=template&id=3834b161&"
import script from "./home-tabs.vue?vue&type=script&lang=js&"
export * from "./home-tabs.vue?vue&type=script&lang=js&"
import style0 from "./home-tabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports